import { signal } from "@preact/signals-react";

import TableRow from "componentsv2/table/TableRow";
import TableRowContent from "componentsv2/table/TableRowContent";
import { useTable } from "storev2/tableStore";

function BodyTable(props) {
  const {
    layout,
    records,
    parentRec,
    onActionButton,
    onClickCell,
    updateRecords,
    fieldName,
    access,
    storeId,
    formStoreId,
    triggerUpdate,
  } = props;
  // console.log("storeId.....", props);

  const { getTable, handleSelected, updateRow } = useTable();
  const cellButtonStart = [];
  const cellButtonEnd = [];
  if (layout.table_action) {
    for (const buttonType of layout.table_action) {
      if (buttonType === "add" || buttonType === "date-card") {
      } else if (buttonType === "edit" || buttonType === "open") {
        cellButtonStart.push(buttonType);
      } else if (buttonType === "delete") {
        const accessDelete = access?.delete
          ? access.delete(parentRec.record)
          : true;
        if (accessDelete) cellButtonEnd.push(buttonType);
      } else {
        cellButtonEnd.push(buttonType);
      }
    }
  }

  function onDoubleClickRow(rec) {
    if (props.onDoubleClick) {
      props.onDoubleClickRow(rec);
    }
  }

  function onClickRow(rec) {
    handleSelected(storeId, rec.value);
    // console.log("onClickRow ? ", rec.value);

    if (props.onClickRow) {
      props.onClickRow(rec.value);
    }
  }

  function onChange(field, value, rec) {
    console.log("onChange ? ", value);
    if (updateRecords) {
      updateRecords(field, value, rec.id);
    }
  }

  function handleCheck() {}

  function getRow(record_, index) {
    const _table = getTable(storeId);
    // if (!_table)
    const selected = _table?.selected;
    // if (!_table) return null;
    // console.log("VAlida............", layout.model, layout.selectable);
    const isChecked = (layout.selectable && selected?.get(record_.id)) || false;
    if (isChecked) {
      // console.log("selected es............", selected, record_.id);
    }
    // console.log("record_............", record_);
    const record = signal(record_);

    const row = (
      <TableRow
        key={index}
        record={record}
        selectable={layout.selectable}
        selectedRows={selected}
        readOnly={props.readOnly}
        onClick={onClickRow}
        isChecked={isChecked}
        onDoubleClick={onDoubleClickRow}
      >
        <TableRowContent
          key={index}
          updateRow={updateRow}
          storeId={storeId}
          isChecked={isChecked}
          layout={layout}
          record={record}
          onActionButton={onActionButton}
          fieldName={fieldName}
          onChange={onChange}
          onClickCell={onClickCell}
          handleCheck={handleCheck}
          cellButtonStart={cellButtonStart}
          cellButtonEnd={cellButtonEnd}
          triggerUpdate={triggerUpdate}
          parentRec={parentRec}
          formStoreId={formStoreId}
        />
      </TableRow>
    );
    return row;
  }

  // console.log("running....1 BODYtable", records);
  let records_ = records || [];
  // records can be of type array, signal(Map) or only a Map
  if (!Array.isArray(records)) {
    let data = records;
    // if (records instanceof Map) {
    //   // records is a Map, convert to array
    //   records_ = Array.from(records.values());
    // }
    if (!(records instanceof Map)) {
      // Because is not a Map, it must be an Signal
      data = records.value;
    }
    if (data && typeof data.values === "function") {
      // Porque se necesita esto?
      records_ = Array.from(data.values());
    } else {
      records_ = [];
    }
  }
  handleSelected;
  if (!records_ || records_.length === 0) return null;

  return (
    <tbody
      key={layout?.modal}
      id="body-table"
      className="h-full w-full mb-10 overflow-y-scroll"
    >
      {records_.map((rec, index) => getRow(rec, index))}
    </tbody>
  );
}

export default BodyTable;
